export default "__VITE_ASSET__DXFTbFBo__"